import cookies from 'js-cookie'

const url = require('is-url')

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}
/**
 *
 * 判断 url query 是否包含指定 key
 * @export
 * @param {*} sVar
 * @returns
 */
export function loadPageVar(sVar) {
  return decodeURI(
    window.location.search.replace(
      new RegExp(
        '^(?:.*[&\\?]' +
          // eslint-disable-next-line no-useless-escape
          encodeURI(sVar).replace(/[\.\+\*]/g, '\\$&') +
          '(?:\\=([^&]*))?)?.*$',
        'i'
      ),
      '$1'
    )
  )
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function generatePassword() {
  var length = 8
  var charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  var retVal = ''
  for (var i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n))
  }
  return retVal
}

/**
 *
 * 获取当前 Account IDP 登陆时所需跳转的地址
 * @export
 * @param {string} accountUri
 * @param {string} returnUrl
 * @returns
 */
export function getCurAccountIdpRedirectEndpoint(accountUri, returnUrl) {
  let defaultEndpoiont = `${process.env.VUE_APP_PROTOCOL}${accountUri}${process.env.VUE_APP_IDAAS_BASE_URL}`
  if (returnUrl && url(decodeURIComponent(returnUrl))) {
    return decodeURIComponent(returnUrl)
  } else {
    return defaultEndpoiont
  }
}

export function isNull(_name) {
  if (_name === '' || _name === undefined || _name === null) return true
  return false
}

export const getToken = () => {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    const urlObj = param2Obj(window.location.href)
    return urlObj.token || ''
  }
  return cookies.get('ss_at') || ''
}

export const getLang = () => {
  // return cookies.get('jdcloud.lang') || navigator.language
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    let ua_lang = ''
    const urlObj = param2Obj(window.location.href)
    if (urlObj.site_lang) {
      switch (urlObj.site_lang) {
        case 'zh-CN':
          ua_lang = 'zh-CN'
          break
        case 'en-US':
          ua_lang = 'en-US'
          break
        default:
          ua_lang = 'zh-CN'
      }
    }
    return ua_lang
  }
  return cookies.get('site_lang') || navigator.language
}

export const setLang = lang => {
  cookies.set('site_lang', lang, { domain: '.ciftis.org' })
  cookies.set('site_lang', lang, { domain: '.ciftis.org.cn' })
}

export function openUrl(_url) {
  if (!_url) return
  let _a = document.createElement('a')
  _a.href = _url
  // _a.target = '_blank'
  document.body.appendChild(_a)
  _a.focus()
  _a.click()
  _a.remove()
}

export const formatUTC = (time, noSec) => {
  if (!time) {
    return '--'
  }
  function formatFunc(str) {
    return str > 9 ? str : '0' + str
  }
  const localTime = new Date(time)
  const year = localTime.getFullYear()
  const mon = formatFunc(localTime.getMonth() + 1)
  const day = formatFunc(localTime.getDate())
  let hour = localTime.getHours()
  hour = formatFunc(hour)
  const min = formatFunc(localTime.getMinutes())
  const sec = formatFunc(localTime.getSeconds())
  const dateStr = noSec
    ? `${year}-${mon}-${day}  ${hour}:${min}:${sec}`
    : `${year}-${mon}-${day}  ${hour}:${min}`
  return dateStr
}
